import React from 'react'
import { PiCaretDoubleRightThin } from "react-icons/pi";

const ProjectHero = () => {
  return (
      <div className='abouthero-backdiv'>
            <div className='backdiv'>
                <div className='about-herogrid'>
                    <div> 
                     <h2 className='main-heading'>LIVE CLOSE TO NATURE, CONNECTED TO THE CITY</h2>
                   <p className='hero-small-text'>PROJECTS<PiCaretDoubleRightThin /> </p>
                    </div>
                    <div className='about-herodiv-wrapper'>
                      <div className='abt-wrap'>
                      <div className="about-herodiv-border">
                    <div className='about-herodiv'>
                        <img className='img-cover' src='./proj-hero1.webp' alt='about' loading='lazy'/>
                    </div>
                    </div>
                     <div className='about-herodiv-second'>
                       <div className='about-herodiv'>
                        <img className='img-cover' src='./proj-hero2.webp' alt='about' loading='lazy'/>
                    </div>
                    
                    </div>
                     <div className='about-herodiv-third'>
                       <div className='about-herodiv'>
                        <img className='img-cover' src='./proj-hero3.webp' alt='about' loading='lazy'/>
                    </div>
                    
                    </div>
                    </div>
                    </div>
           
            </div>
            </div>
        </div>
  )
}

export default ProjectHero